import { AppContainer } from 'shared/app/AppContainer';
import { renderApp } from 'shared/app/AppRenderer';
import { initHeapCarrierGuidSync } from 'shared/helpers/Analytics';
import { LoadboardWebviewApp } from './LoadboardWebviewApp';

initHeapCarrierGuidSync();

renderApp(
  <AppContainer>
    <LoadboardWebviewApp />
  </AppContainer>,
);
